"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartIdSelector = void 0;
var getChartIdSelector = function (state) { return state.chartId; };
exports.getChartIdSelector = getChartIdSelector;
//# sourceMappingURL=get_chart_id.js.map